import Link from 'next/link';
import { FC } from 'react';

import { Icon, IconName } from '@/shared/ui';

import styles from './chooseArticleType.module.scss';

interface ChooseArticleTypeProps {
  slug: string;
  icon: IconName;
  title: string;
  description: string;
  closeModal: () => void;
}

const ChooseArticleType: FC<ChooseArticleTypeProps> = (props) => {
  const { slug, icon, title, description, closeModal } = props;
  return (
    <Link
      className={styles.container}
      href={`/articles/${slug}`}
      onClick={closeModal}
    >
      <div className={styles.container__iconBlock}>
        <Icon className={styles.container__icon} name={icon} size={56} />
      </div>
      <div className={styles.container__content}>
        <div className={styles.container__titleBlock}>
          <p className={styles.container__title}>{title}</p>
        </div>

        <p className={styles.container__text}>{description}</p>
      </div>
    </Link>
  );
};

export default ChooseArticleType;
